var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Styles.module.scss';
import classNames from "classnames";
import { useForm } from "react-hook-form";
import { getAuth, updateProfile } from "firebase/auth";
import Preloader from '../../assets/preloader.svg';
import { channelAPI, profileAPI } from "../../API/api";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
// const LOGIN_REGEXP = /^[a-zA-Z0-9_*-]{4,20}$/;
const LOGIN_REGEXP = /^[a-zA-Z0-9_*\- ]{4,20}$/;
const NAME_CHANNEL_REGEXP = /^[\p{L}0-9_*\s-]{4,20}$/u;
//const NAME_CHANNEL_REGEXP = /^[a-zA-Z0-9_*\s-]{4,20}$/;
const URL_REGEXP = /^((ftp|http|https):\/\/)?(www\.)?([A-Za-zА-Яа-я0-9]{1}[A-Za-zА-Яа-я0-9\-]*\.?)*\.{1}[A-Za-zА-Яа-я0-9-]{2,8}(\/([\w#!:.?+=&%@!\-\/])*)?/;
const ChangeUserInfoForm = ({ changeInfo, setChangeInfo, currentUserInfo }) => {
    var _a, _b;
    const { t } = useTypedTranslation();
    const isChannel = !!(currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.channel);
    const displayName = isChannel ? currentUserInfo.channel.displayName : currentUserInfo.displayName;
    const photoURL = isChannel ? (_a = currentUserInfo.channel) === null || _a === void 0 ? void 0 : _a.photoURL : currentUserInfo.photoURL;
    const { handleSubmit, register, formState: { errors, isSubmitting, isValidating } } = useForm({
        mode: 'onBlur',
        defaultValues: {
            displayName: displayName,
            photoURL: photoURL
        }
    });
    const validateDisplayName = (value) => __awaiter(void 0, void 0, void 0, function* () {
        if (value === displayName)
            return true;
        const isValid = yield profileAPI.checkDisplayName(value);
        return isValid || t('form.userAlreadyExists');
    });
    const submit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        if (isChannel) {
            channelAPI.changeCannelInfo({ channel: Object.assign(Object.assign({}, currentUserInfo.channel), { displayName: data.displayName, photoURL: data.photoURL }) })
                .then(() => setChangeInfo(false))
                .catch(err => console.log('ошибка изменения канала', err));
        }
        else {
            const auth = getAuth();
            yield updateProfile(auth.currentUser, {
                displayName: data.displayName, photoURL: data.photoURL
            }).then(() => {
                profileAPI.changeUserInfo(Object.assign(Object.assign({}, currentUserInfo), { photoURL: data.photoURL, displayName: data.displayName }));
                setChangeInfo(false);
            }).catch((error) => {
                console.log('уууупс....');
            });
        }
    });
    return (_jsx("div", { className: classNames(styles.changeUserInfo, { [styles.changeUserInfo_show]: changeInfo }), children: _jsx("div", { className: classNames(styles.changeUserInfo__wrapper, { [styles.changeUserInfo__wrapper_show]: changeInfo }), children: _jsxs("form", { onSubmit: handleSubmit(submit), children: [_jsx("div", { className: styles.changeUserInfo__item, children: _jsx("input", Object.assign({ type: "text", className: classNames({ [styles.error]: errors.displayName }), placeholder: t('form.userName') + '. ' + t('form.min') }, register('displayName', {
                            maxLength: 20,
                            minLength: 4,
                            pattern: isChannel ? NAME_CHANNEL_REGEXP : LOGIN_REGEXP,
                            required: { value: true, message: t('form.required') },
                            validate: validateDisplayName
                        }))) }), _jsx("div", { className: styles.changeUserInfo__item, children: _jsx("input", Object.assign({ type: "text", className: classNames({ [styles.error]: errors.photoURL }), placeholder: "Photo URL" }, register('photoURL', { pattern: URL_REGEXP }))) }), _jsx("div", { className: styles.changeUserInfo__item, children: _jsx("span", { className: styles.errorMessage, children: (_b = errors.displayName) === null || _b === void 0 ? void 0 : _b.message }) }), _jsx("div", { className: styles.changeUserInfo__item, children: _jsx("button", { disabled: isSubmitting || isValidating, children: isSubmitting ? _jsx(Preloader, {}) : t('save') }) })] }) }) }));
};
export default ChangeUserInfoForm;
